import { APPMessages, PostAppMessage } from './AppUtil';

const LOGINLEVEL_KEY = 'yw_ll';

export const storageProviders = {
    App: 'App',
    Session: 'Session',
    Local: 'Local',
};

let storageProvider = window.localStorage;
const storage = {};

class Auth {
    static setStorageProvider(provider) {
        switch (provider) {
        case storageProviders.App:
            storageProvider = {
                getItem: key => storage[key],
                setItem: (key, value) => { storage[key] = value; },
            };
            break;
        case storageProviders.Session:
            storageProvider = window.sessionStorage;
            break;
        case storageProviders.Local:
            storageProvider = window.localStorage;
            break;
        default:
            break;
        }
    }

    static isUserAuthenticated() {
        return this.getLoginLevel() > 0;
    }

    static deauthenticateUser() {
        this.setLoginInfo(0);
    }

    static getLoginLevel() {
        return Number(storageProvider.getItem(LOGINLEVEL_KEY));
    }

    static setLoginInfo(level) {
        storageProvider.setItem(LOGINLEVEL_KEY, level);

        PostAppMessage(APPMessages.LoggedInLevel, level);
    }
}

export default Auth;
